import React from 'react';
import { withRouter } from "react-router";
import poweredByDq from '../../../assets/images/PoweredByDQ_Default.png';

/*
 * Parent Information Letter — the page the "Information Letter" links open,
 * from the parental consent page and from the footer of the consent emails.
 *
 * The text is the Information Letter email's own, word for word (LP-04,
 * DQ_PARENT_INFORMATION_LETTER in the API's learner_parent.js) — change one,
 * and the other must follow. English only, like the email.
 * Look: the same as the consent page and the email it mirrors.
 */

const DPO_EMAIL = 'dpo@dqforall.com';

const InformationLetter = (props) => {

    const {location} = props;
    const pageLc = location.pathname.split('/')[1];

    return (
        <div className="consent-shell">
            <div className="consent-page">
                <div className="consent-header">
                    <img src={poweredByDq} alt="Powered by DQ" />
                </div>

                <div className="consent-title">Information about your child's Child Online Safety program</div>

                <p className="consent-text">Dear Parent or Guardian,</p>
                <p className="consent-text">
                    We are pleased that your child will have the opportunity to take part in the COS Children
                    Assessment and targeted learning programs. These are designed to build critical digital skills
                    and resilience for the digital world.
                </p>

                <h3 className="consent-heading">Why this matters</h3>
                <p className="consent-text">
                    The COS Children Assessment and learning programs align with the internationally recognized
                    IEEE DQ Standards 3527.1 and the Child Protection in Cyberspace (CPC) Index, giving globally
                    benchmarked, actionable feedback for your child's safe and empowered digital life.
                </p>

                <h3 className="consent-heading">What your child will do</h3>
                <ul className="consent-list">
                    <li>
                        Complete an online assessment, about 45 minutes, on a secure mobile or web platform,
                        covering online safety readiness, risk experiences and support systems.
                    </li>
                    <li>
                        They may take part in learning activities based on their assessment results, with a
                        pre-check and post-check so progress can be measured.
                    </li>
                </ul>

                <h3 className="consent-heading">Privacy and security</h3>
                <p className="consent-text">
                    All information is handled securely and used to give your child personalized feedback and to
                    support national measurement using aggregate data, with no individual child identified
                    publicly. Individual data is private to you and your child. We follow strict data-protection
                    standards aligned to the GDPR. Full details are in the Privacy Policy.
                </p>

                <h3 className="consent-heading">What happens next</h3>
                <p className="consent-text">
                    Your child's account is activated either through the school or by your confirmation. You can
                    always review the Terms of Use and the Privacy Policy before your child begins, and object or
                    withdraw at any time. When your child finishes, they receive a personal scorecard with
                    insights and next steps.
                </p>

                <p className="consent-text">
                    If you have any questions, contact us at <a className="consent-mail" href={`mailto:${DPO_EMAIL}`}>{DPO_EMAIL}</a>.
                </p>
                <p className="consent-text">
                    Thank you for helping children grow into confident, responsible digital citizens.
                </p>

                <p className="consent-text consent-signoff">Best,<br/><b>The DQ Team</b></p>

                <p className="consent-small">
                    <a className="consent-muted" href={`/${pageLc}/privacy_policy`} target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                    {' · '}Questions: <a href={`mailto:${DPO_EMAIL}`}>{DPO_EMAIL}</a>
                </p>

                <div className="consent-footer">
                    <img src={poweredByDq} alt="Powered by DQ" />
                </div>
            </div>
        </div>
    );
};

export default withRouter(InformationLetter);
